import { WarningCircleSolidIcon } from '@/ui/Icons/WarningCircleSolidIcon';
import {
  MatchaTooltip,
  MatchaTooltipBottomSheet,
  MatchaTooltipContent,
  MatchaTooltipPopover,
  MatchaTooltipTrigger,
} from '@/ui/MatchaTooltip';

import type { LimitOrderItem } from '@/utils/0x.types';

interface OrderStatusCellProps {
  /** The open limit order whose status is displayed. */
  item: LimitOrderItem;
}

/**
 * Renders an open limit order's status. An order the maker can no longer cover
 * takes precedence over fill progress, since it will never fill until the maker
 * tops up their balance or cancels.
 */
export function OrderStatusCell({ item }: OrderStatusCellProps) {
  if (!item.insufficientBalance) {
    return <span>{item.status || 'Unknown status'}</span>;
  }

  const symbol = item.makerTokenResult?.symbol;

  return (
    <MatchaTooltip>
      <MatchaTooltipTrigger>
        <button
          type="button"
          onClick={(event) => event.stopPropagation()}
          className="text-token-red-1300 items-center flex gap-1.5"
        >
          <WarningCircleSolidIcon className="size-4 text-token-red-900 shrink-0" />
          Insufficient balance
        </button>
      </MatchaTooltipTrigger>
      <MatchaTooltipContent>
        {symbol ? `Your ${symbol} balance is ` : 'Your balance of the sell token is '}lower than
        this order&apos;s sell amount, so it cannot be filled. Add funds or cancel the order.
      </MatchaTooltipContent>
      <MatchaTooltipPopover sideOffset={8} />
      <MatchaTooltipBottomSheet header="Insufficient balance" />
    </MatchaTooltip>
  );
}
